import Popups from "./../Popups";
import Forms from "./../Forms";
import Attributes from "./Attributes";
import Messages from "./../../library/Messages";
import Tooltips from "./../Tooltips";

export default class Engravings {
	constructor() {
		this.instance = self;
		this.objectUrlMap = {};
		this.popupsInstance = new Popups();
	}

	static init() {
		const self = new Engravings();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;
		self.initPlaqueEngravingCounters();
		self.initEngravingEditPopupCounters();
		self.initEngravingPanelState();
		self.syncEngravingsNotes();
		self.syncEngravingEditPopupNotes();

		$(document).on("change", ".js-engravings-input.js-engraving-check", function () {
			const engravingId = $(this).data("engraving-id");
			const isEnabled = $(this).is(":checked");
			self.toggleEngravingTabs(engravingId, isEnabled, true);
			self.syncEngravingsNotes();
		});

		$(document).on("keyup change", ".js-plaque-line-input", function () {
			const $group = $(this).closest(".js-plaque-item-group");
			const $wrapper = $(this).closest(".js-plaque-engraving-wrapper");
			self.updatePlaqueGroupCounter($wrapper, $group);
			self.serializePlaqueNotes($wrapper);
			Attributes.setTeamPrice();
		});

		$(document).on("keyup change", ".js-engraving-text", function () {
			self.syncEngravingsNotes();
		});

		$(document).on("keyup change", ".js-engraving-edit-line-input", function () {
			const $item = $(this).closest(".js-engraving-edit-item");
			const $wrapper = $(this).closest(".js-engraving-edit-wrapper");
			self.updateEngravingEditPopupCounter($wrapper, $item);
		});

		$(document).on("keyup change", ".js-product-team-quantity-input", function () {
			self.syncPlaqueEngravingGroups();
			Attributes.setTeamPrice();
		});

		$(document).on("click", ".js-add-product-team-quantity-row, .js-remove-product-team-quantity-row", function () {
			setTimeout(function () {
				self.syncPlaqueEngravingGroups();
				Attributes.setTeamPrice();
			}, 0);
		});

		$(document).on("click", ".js-copy-engraving-next-item", function (e) {
			e.preventDefault();
			const $sourceGroup = $(this).closest(".js-plaque-item-group");
			const $wrapper = $(this).closest(".js-plaque-engraving-wrapper");
			const $targetGroup = $sourceGroup.next(".js-plaque-item-group");

			if ($sourceGroup.length === 0 || $targetGroup.length === 0 || $wrapper.length === 0) {
				return;
			}

			self.copyPlaqueGroupInputValues($sourceGroup, $targetGroup);
			self.updatePlaqueGroupCounter($wrapper, $targetGroup);
			self.serializePlaqueNotes($wrapper);
			Attributes.setTeamPrice();
		});

		$(document).on("click", ".js-copy-engraving-all-items", function (e) {
			e.preventDefault();
			const $sourceGroup = $(this).closest(".js-plaque-item-group");
			const $wrapper = $(this).closest(".js-plaque-engraving-wrapper");

			if ($sourceGroup.length === 0 || $wrapper.length === 0) {
				return;
			}

			$wrapper.find(".js-plaque-item-group").each(function () {
				const $targetGroup = $(this);
				if ($targetGroup[0] === $sourceGroup[0]) {
					return;
				}

				self.copyPlaqueGroupInputValues($sourceGroup, $targetGroup);
				self.updatePlaqueGroupCounter($wrapper, $targetGroup);
			});

			self.serializePlaqueNotes($wrapper);
			Attributes.setTeamPrice();
		});

		$(document).on("click", ".js-remove-plaque-item-group", function (e) {
			e.preventDefault();
			const $group = $(this).closest(".js-plaque-item-group");
			const $wrapper = $(this).closest(".js-plaque-engraving-wrapper");

			if ($group.length === 0 || $wrapper.length === 0) {
				return;
			}

			const groupCount = $wrapper.find(".js-plaque-item-group").length;
			const engravingId = $wrapper.data("engraving-id");

			if (groupCount <= 1) {
				self.clearPlaqueGroupInputs($group);
				self.serializePlaqueNotes($wrapper);
				self.toggleEngravingTabs(engravingId, false, true);
				$(".js-engravings-input.js-engraving-check[data-engraving-id='" + engravingId + "']").prop("checked", false).trigger("change");
				return;
			}

			$group.remove();
			self.decrementTeamQuantity();
		});


		$(document).on('click', '.js-engraving-image', function (e) {
			e.preventDefault();
			let $el = $(this);
			let positionId = $el.data('position-id');
			let engravingId = $el.data('engraving-id');
			let engravingName = $el.data('engraving-name') || '';
			$('#selected_engraving_' + positionId).val(engravingId);
			$('#engraving_name_' + positionId).text(engravingName);

			$('.engraving-image-filename').removeClass('d-none');
			self.syncEngravingsNotes();
		});

		$(document).on('click', '.js-remove-engraving-image', function (e) {
			e.preventDefault();
			const $el = $(this);
			console.log($el)
			let parentContainer = $el.closest(".engraving-container");
			let engravingImages =  parentContainer.find(".js-engraving-image");
			engravingImages.removeClass("active");
			let engravingSelectedText = parentContainer.find(".engraving-image-filename");
			engravingSelectedText.addClass("d-none");
			self.syncEngravingsNotes();
		});

        $(document).on('click keydown', '.js-engraving-file-trigger, .js-engraving-file-label', function (e) {
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
			e.preventDefault();
			let engravingId = $(this).data('engraving-id');
			if (!engravingId) return;
			$('#engraving-upload-' + engravingId).trigger('click');
		});


        $(document).on('change', '.js-engraving-file-input', (e) => {
            let $input = $(e.currentTarget);
            let pos = $input.data('position-id');
            let file = e.currentTarget.files && e.currentTarget.files[0];
            let $container = $('.engraving-file-upload-area-thumbnail[data-position-id="' + pos + '"]');
            let $icon = $container.find('.engraving-file-upload-area-thumbnail-icon');
            let $preview = $container.find('.engraving-file-upload-preview');
            let $label = $('.js-engraving-file-label[data-position-id="' + pos + '"]');
            let $name = $label.find('.js-engraving-file-name');
            let $remove = $label.find('.js-engraving-file-remove');

			if (file) {
				let fileName = file.name;
				let lastDotIndex = fileName.lastIndexOf('.');
				let fileExt = fileName.slice(lastDotIndex);
				$('#engraving-uploadext-' + pos).val(fileExt);
			} else {
				$('#engraving-uploadext-' + pos).val('');
			}


            if (this.objectUrlMap[pos]) {
                URL.revokeObjectURL(this.objectUrlMap[pos]);
                delete this.objectUrlMap[pos];
            }

            if (file) {
				if (file.type == "application/postscript"){
						let fileName = file.name;
						const lastDotIndex = fileName.lastIndexOf('.')
						let fileExtension = fileName.slice(lastDotIndex);
						if (fileExtension == ".ai"){
							$(".illustrator-icon").removeClass("d-none")
							$(".eps-icon").addClass("d-none")
							const url = URL.createObjectURL(file);
							this.objectUrlMap[pos] = url;
							$icon.addClass('d-none');
							$name.text(file.name).removeClass('d-none');
							$remove.removeClass('d-none');
							$label.find('.js-engraving-file-label-text').addClass('d-none');
							$('#engraving-' + pos + '-filename').val(file.name);
						} else if ( fileExtension == ".eps") {
							$(".illustrator-icon").addClass("d-none")
							$(".eps-icon").removeClass("d-none")
							const url = URL.createObjectURL(file);
							this.objectUrlMap[pos] = url;
							$icon.addClass('d-none');
							$name.text(file.name).removeClass('d-none');
							$remove.removeClass('d-none');
							$label.find('.js-engraving-file-label-text').addClass('d-none');
							$('#engraving-' + pos + '-filename').val(file.name);
						};
				} else {
					let url = URL.createObjectURL(file);
					this.objectUrlMap[pos] = url;
					$preview.attr('src', url).removeClass('d-none');
					$icon.addClass('d-none');
					$name.text(file.name).removeClass('d-none');
					$remove.removeClass('d-none');
					$label.find('.js-engraving-file-label-text').addClass('d-none');
					$('#engraving-' + pos + '-filename').val(file.name);
				}}
        	 else{
                $preview.attr('src', '').addClass('d-none');
                $icon.removeClass('d-none');
                $name.text('').addClass('d-none');
                $remove.addClass('d-none');
                $label.find('.js-engraving-file-label-text').removeClass('d-none');
                $('#engraving-' + pos + '-filename').val('');
            }

			this.syncEngravingsNotes();
        });

        $(document).on('click', '.js-engraving-file-remove', (e) => {
            e.preventDefault();
			e.stopPropagation();
            let $btn = $(e.currentTarget);
            let $label = $btn.closest('.js-engraving-file-label');
            let pos = $label.data('position-id');
            let $input = $('#engraving-file-' + pos);
            let $container = $('.engraving-file-upload-area-thumbnail[data-position-id="' + pos + '"]');
            let $icon = $container.find('.engraving-file-upload-area-thumbnail-icon');
            let $preview = $container.find('.engraving-file-upload-preview');

            if (this.objectUrlMap[pos]) {
                URL.revokeObjectURL(this.objectUrlMap[pos]);
                delete this.objectUrlMap[pos];
            }

            const newInput = $('<input>', {
                type: 'file',
                id: $input.attr('id'),
                name: $input.attr('name'),
                accept: $input.attr('accept'),
                'data-position-id': pos,
                class: $input.attr('class')
            });
            $input.replaceWith(newInput);
			$(".illustrator-icon").addClass("d-none")
			$(".eps-icon").addClass("d-none")
            $preview.attr('src', '').addClass('d-none');
            $icon.removeClass('d-none');
            $label.find('.js-engraving-file-name').text('').addClass('d-none');
            $btn.addClass('d-none');
            $label.find('.js-engraving-file-label-text').removeClass('d-none');
            $('#engraving-' + pos + '-filename').val('');
			$('#engraving-uploadext-' + pos).val('');
			this.syncEngravingsNotes();
        });

		$(document).on("click", ".js-engraving-basket-link", function (e) {
			e.preventDefault();
			self.openBasketPopup($(this));
		});

		$(document).on("ajaxComplete", function () {
			self.syncEngravingEditPopupNotes();
		});
	}


	openBasketPopup($link) {
		const self = this,
			url = self.getCustomiseBasketLink($link);

		if (!url) {
			return;
		}

		if (!self.popupsInstance) {
			self.popupsInstance = new Popups();
		}

		self.popupsInstance.openAjaxCentralPopup(url);
	}

	getCustomiseBasketLink($link) {
		let url = $link.data("href"),
			$basketItem = $link.parents(".basket-item");
		const basketItemId = $link.data("item-id") || $basketItem.data("item-id");

		if (!url || !basketItemId) {
			return "";
		}

		url +=
			"?basket=true&team=true&item_id=" +
			basketItemId +
			($basketItem.data("bundle-instance")
				? "&bundle=true&bundle_instance=" + $basketItem.data("bundle-instance")
				: "");

		return url;
	}

	initEngravingPanelState() {
		const self = this;
		$(".js-engravings-input.js-engraving-check").each(function () {
			const engravingId = $(this).data("engraving-id");
			const isEnabled = $(this).is(":checked");
			self.toggleEngravingTabs(engravingId, isEnabled, false);
		});
	}

	toggleEngravingTabs(engravingId, isEnabled, useAnimation = true) {
		const $tabs = $(`.engraving-${engravingId}-tabs`);
		if ($tabs.length === 0) {
			return;
		}

		if (isEnabled) {
			if (useAnimation) {
				$tabs.slideDown(250);
			} else {
				$tabs.show();
			}
		} else {
			if (useAnimation) {
				$tabs.slideUp(250);
			} else {
				$tabs.hide();
			}
		}
	}

	initPlaqueEngravingCounters() {
		const self = this;
		self.syncPlaqueEngravingGroups();
		$(".js-plaque-engraving-wrapper").each(function () {
			const engravingId = $(this).data("engraving-id");
			self.updatePlaqueEngravingCounter(engravingId);
		});
	}

	initEngravingEditPopupCounters() {
		const self = this;

		$(".js-engraving-edit-wrapper").each(function () {
			const $wrapper = $(this);
			$wrapper.find(".js-engraving-edit-item").each(function () {
				self.updateEngravingEditPopupCounter($wrapper, $(this));
			});
		});
	}

	getTeamQuantityTotal() {
		let quantityTotal = 0;
		let hasQuantityInputs = false;

		$(".js-product-team-quantity-input").each(function () {
			hasQuantityInputs = true;
			const quantity = parseInt($(this).val(), 10);
			if (!Number.isNaN(quantity) && quantity > 0) {
				quantityTotal += quantity;
			}
		});

		if (hasQuantityInputs) {
			return quantityTotal;
		}

		return quantityTotal > 0 ? quantityTotal : 1;
	}

	decrementTeamQuantity() {
		const quantityInputs = $(".js-product-team-quantity-input").toArray().reverse();

		for (let index = 0; index < quantityInputs.length; index += 1) {
			const $input = $(quantityInputs[index]);
			const quantity = parseInt($input.val(), 10);

			if (!Number.isNaN(quantity) && quantity > 0) {
				$input.val(quantity - 1).trigger("change");
				return;
			}
		}
	}

	clearPlaqueGroupInputs($group) {
		$group.find(".js-plaque-line-input").val("");
		$group.find(".js-plaque-char-counter").text("");
		$group.find(".js-plaque-over-limit-message").text("").addClass("d-none");
	}

	parseEngravingNotes(notes) {
		if (!notes) {
			return [];
		}

		if (Array.isArray(notes)) {
			return notes;
		}

		if (typeof notes !== "string") {
			return [];
		}

		const trimmedNotes = notes.trim();

		if (!trimmedNotes) {
			return [];
		}

		if (trimmedNotes.charAt(0) !== "[" && trimmedNotes.charAt(0) !== "{") {
			return [trimmedNotes];
		}

		try {
			const parsedNotes = JSON.parse(trimmedNotes);
			return Array.isArray(parsedNotes) ? parsedNotes : [parsedNotes];
		} catch (error) {
			return [];
		}
	}

	syncEngravingEditPopupNotes() {
		const self = this;

		$(".js-engraving-edit-wrapper:not([data-engraving-edit-initialized='1'])").each(function () {
			const $wrapper = $(this);
			const parsedNotes = self.parseEngravingNotes($wrapper.data("engraving-notes"));

			$wrapper.find(".js-engraving-edit-item").each(function () {
				const $item = $(this);
				const itemIndex = parseInt($item.attr("data-item-index"), 10) || 0;
				const itemNotes = Array.isArray(parsedNotes[itemIndex])
					? parsedNotes[itemIndex]
					: (itemIndex === 0 && parsedNotes.length && !Array.isArray(parsedNotes[0]) ? parsedNotes : []);

				$item.find(".js-engraving-edit-line-input").each(function () {
					const $input = $(this);
					const lineIndex = parseInt($input.data("line-index"), 10) || 0;
					$input.val(itemNotes[lineIndex] || "");
				});

				self.updateEngravingEditPopupCounter($wrapper, $item);
			});

			$wrapper.attr("data-engraving-edit-initialized", "1");
		});
	}

	updateEngravingEditPopupCounter($wrapper, $item) {
		if ($wrapper.length === 0 || $item.length === 0) {
			return;
		}

		const freeCharacterLimit = parseInt($wrapper.data("free-character-limit"), 10) || 0;
		const extraCharacterCost = parseFloat($wrapper.data("extra-character-cost")) || 0;
		let totalCharacters = 0;

		$item.find(".js-engraving-edit-line-input").each(function () {
			totalCharacters += ($(this).val() || "").length;
		});

		const $counter = $item.find(".js-engraving-edit-char-counter").first();
		if ($counter.length) {
			$counter.text(`${totalCharacters} / ${freeCharacterLimit} free characters used`);
		}

		const $message = $item.find(".js-engraving-edit-over-limit-message").first();
		if ($message.length) {
			if (totalCharacters > freeCharacterLimit) {
				const overBy = totalCharacters - freeCharacterLimit;
				$message
					.text(`You have exceeded the free character limit by ${overBy}. Total extra cost for engraving is £${extraCharacterCost.toFixed(2)}.`)
					.removeClass("d-none");
			} else {
				$message.text("").addClass("d-none");
			}
		}
	}

	syncPlaqueEngravingGroups() {
		const self = this;
		const targetQuantity = self.getTeamQuantityTotal();

		$(".js-plaque-engraving-wrapper").each(function () {
			const $wrapper = $(this);
			self.syncPlaqueGroupsForWrapper($wrapper, targetQuantity);
		});
	}

	syncPlaqueGroupsForWrapper($wrapper, targetQuantity) {
		const self = this;
		const $groupsContainer = $wrapper.find(".js-plaque-item-groups");
		let $groups = $groupsContainer.children(".js-plaque-item-group");

		if ($groups.length === 0) {
			return;
		}

		const $firstGroup = $groups.first();

		while ($groups.length < targetQuantity) {
			const nextIndex = $groups.length + 1;
			const $newGroup = $firstGroup.clone(false, false);
			$newGroup.find(".js-plaque-line-input").val("");
			$newGroup.find(".js-plaque-char-counter").text("");
			$newGroup.find(".js-plaque-over-limit-message").text("").addClass("d-none");
			self.updatePlaqueGroupLabel($newGroup, nextIndex);
			$groupsContainer.append($newGroup);

			// Initialise tooltips on the newly cloned links
			$newGroup.find(".js-tooltip-trigger").each(function () {
				Tooltips.initTooltip($(this));
			});

			$groups = $groupsContainer.children(".js-plaque-item-group");
		}

		while ($groups.length > targetQuantity) {
			$groups.last().remove();
			$groups = $groupsContainer.children(".js-plaque-item-group");
		}

		$groups.not(":first").find(".js-copy-engraving-all-items").remove();

		$groups.each(function (groupIndex) {
			const $group = $(this);
			self.updatePlaqueGroupLabel($group, groupIndex + 1);
			self.updatePlaqueGroupCounter($wrapper, $group);
		});

		self.serializePlaqueNotes($wrapper);
		self.updateCopyLinksState($wrapper);
	}

	updateCopyLinksState($wrapper) {
		const $groups = $wrapper.find(".js-plaque-item-group");
		const $copyLinks = $wrapper.find(".js-copy-engraving-all-items, .js-copy-engraving-next-item");

		if ($groups.length <= 1) {
			$copyLinks.addClass("d-none");
		} else {
			$copyLinks.removeClass("d-none");

			// Hide "Copy to next item" on the last group because there is no next item
			$groups.last().find(".js-copy-engraving-next-item").addClass("d-none");

			// Make sure "Copy to all" only appears on the first group
			$groups.not(":first").find(".js-copy-engraving-all-items").addClass("d-none");
		}
	}

	updatePlaqueGroupLabel($group, itemIndex) {
		$group.attr("data-item-index", itemIndex);
		$group.find("label").first().text(`Instructions for engraving - Item ${itemIndex}`);
	}

	updatePlaqueEngravingCounter(engravingId) {
		const $wrapper = $(`.js-plaque-engraving-wrapper[data-engraving-id="${engravingId}"]`);
		if ($wrapper.length === 0) {
			return;
		}

		const self = this;
		$wrapper.find(".js-plaque-item-group").each(function () {
			self.updatePlaqueGroupCounter($wrapper, $(this));
		});
		self.serializePlaqueNotes($wrapper);
	}

	updatePlaqueGroupCounter($wrapper, $group) {
		if ($wrapper.length === 0 || $group.length === 0) {
			return;
		}

		const freeCharacterLimit = parseInt($wrapper.data("free-character-limit"), 10) || 0;
		const extraCharacterCost = parseFloat($wrapper.data("extra-character-cost")) || 0;
		let totalCharacters = 0;

		$group.find(".js-plaque-line-input").each(function () {
			totalCharacters += ($(this).val() || "").length;
		});

		const $counter = $group.find(".js-plaque-char-counter");
		$counter.text(`${totalCharacters} / ${freeCharacterLimit} free characters used`);

		const $message = $group.find(".js-plaque-over-limit-message");
		if (totalCharacters > freeCharacterLimit) {
			const overBy = totalCharacters - freeCharacterLimit;
			$message
				.text(`You have exceeded the free character limit by ${overBy}. Total extra cost for engraving is £${(extraCharacterCost).toFixed(2)}.`)
				.removeClass("d-none");
		} else {
			$message.text("").addClass("d-none");
		}
	}

	copyPlaqueGroupInputValues($sourceGroup, $targetGroup) {
		if ($sourceGroup.length === 0 || $targetGroup.length === 0) {
			return;
		}

		$sourceGroup.find(".js-plaque-line-input").each(function () {
			const lineIndex = $(this).data("line-index");
			const value = $(this).val();
			$targetGroup
				.find(`.js-plaque-line-input[data-line-index="${lineIndex}"]`)
				.val(value);
		});
	}

	serializePlaqueNotes($wrapper) {
		this.syncEngravingsNotes();
	}

	getTeamRows() {
		const rows = [];

		$(".js-product-team-quantity-row").each(function () {
			const teamUuid = $(this).data("team-uuid");
			const quantity = parseInt($(this).find(".js-product-team-quantity-input").val(), 10);

			if (teamUuid && !Number.isNaN(quantity) && quantity > 0) {
				rows.push({
					teamUuid,
					quantity,
				});
			}
		});

		return rows;
	}

	buildPlaqueNotesByTeamRow(plaqueItems) {
		const teamRows = this.getTeamRows();

		if (!teamRows.length) {
			return [];
		}

		const groupedItems = [];
		let plaqueItemIndex = 0;

		teamRows.forEach((teamRow) => {
			const rowPlaqueItems = plaqueItems.slice(plaqueItemIndex, plaqueItemIndex + teamRow.quantity);
			plaqueItemIndex += teamRow.quantity;

			groupedItems.push({
				teamUuid: String(teamRow.teamUuid),
				notes: JSON.stringify(rowPlaqueItems),
			});
		});

		if (plaqueItemIndex < plaqueItems.length && groupedItems.length) {
			const lastGroupedItem = groupedItems[groupedItems.length - 1];
			const lastNotes = JSON.parse(lastGroupedItem.notes);
			lastNotes.push(...plaqueItems.slice(plaqueItemIndex));
			lastGroupedItem.notes = JSON.stringify(lastNotes);
		}

		return groupedItems;
	}

	buildPlaqueEngravingEntries($wrapper) {
		const $checkbox = $wrapper.find(".js-engravings-input.js-engraving-check").first();
		const engravingId = $checkbox.data("engraving-id");

		if (!$checkbox.length || !$checkbox.is(":checked")) {
			return [];
		}

		const $plaqueWrapper = $wrapper.find(".js-plaque-engraving-wrapper").first();

		if (!$plaqueWrapper.length) {
			return [];
		}

		const plaqueItems = [];

		$plaqueWrapper.find(".js-plaque-item-group").each(function () {
			const lines = [];

			$(this).find(".js-plaque-line-input").each(function () {
				lines.push(($(this).val() || "").trim());
			});

			plaqueItems.push(lines);
		});

		return this.buildPlaqueNotesByTeamRow(plaqueItems).map((entry) => {
			return {
				teamUuid: entry.teamUuid,
				notes: entry.notes,
				engravingId,
			};
		});
	}

	appendGeneratedInput($container, name, value) {
		$("<input>", {
			type: "hidden",
			name,
			value,
		}).appendTo($container);
	}

	syncEngravingsNotes() {
		const $generatedInputs = $(".js-generated-engraving-inputs");
		let entryIndex = 1;

		$generatedInputs.empty();

		$(".product-engraving-wrapper").each((index, element) => {
			const $wrapper = $(element);
			const $notesField = $wrapper.find(".js-plaque-notes-hidden");
			const plaqueEntries = this.buildPlaqueEngravingEntries($wrapper);

			if ($notesField.length) {
				$notesField.val("");
			}

			plaqueEntries.forEach((entry) => {
				this.appendGeneratedInput($generatedInputs, `engraving[${entryIndex}][id]`, entry.engravingId);
				this.appendGeneratedInput($generatedInputs, `engraving[${entryIndex}][is_enabled]`, "on");
				this.appendGeneratedInput($generatedInputs, `engraving[${entryIndex}][team_uuid]`, entry.teamUuid);
				this.appendGeneratedInput($generatedInputs, `engraving[${entryIndex}][notes]`, entry.notes);
				entryIndex += 1;
			});
		});

		if ($generatedInputs.children().length === 0) {
			$generatedInputs.empty();
			}
	}

	getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}
}
